var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestEmailTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#781BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7577 33.5662L42.8845 40.7089C42.0699 41.3485 41.0643 41.6962 40.0286 41.6962C38.993 41.6962 37.9873 41.3485 37.1728 40.7089L28.2246 33.5662",
    stroke: "#781BFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.167 22H49.7773C52.6061 22.0312 55.2955 23.2272 57.2237 25.3072C58.1788 26.3393 58.9155 27.5538 59.3894 28.8777C59.8634 30.2017 60.0649 31.6078 59.9818 33.0115V46.5898C60.0649 47.9935 59.8634 49.3996 59.3894 50.7236C58.9155 52.0475 58.1788 53.262 57.2237 54.2941C56.2723 55.3223 55.1213 56.1458 53.841 56.7144C52.5608 57.2831 51.178 57.5848 49.7773 57.6013H30.167C24.0934 57.6013 20 52.6613 20 46.5898V33.0115C20 26.94 24.0934 22 30.167 22Z",
    stroke: "#781BFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestEmailTemplates);
export default __webpack_public_path__ + "static/media/BestEmailTemplates.2a39704d830395c88ecc3ec973393f63.svg";
export { ForwardRef as ReactComponent };